export enum NewsLinkCellBlock {
  Root = 'NewsLinkCell',
}

export enum NewsLinkCellElement {
  Date = 'date',
}
